import standardStyles from "exports.module.scss";
import { useEffect, useState } from "react";

import { getDimensionFromCSSVar } from "seneca-common/utils/functions";

export const SIDEBAR_TRANSITION_TIME =
  1000 * getDimensionFromCSSVar(standardStyles.sidebartransitiontime, "s");

export function useTransitionTimeout(opened: boolean) {
  const [transitionEnded, setTransitionEnded] = useState(true);

  useEffect(() => {
    if (!opened) {
      setTransitionEnded(false);
      const transitionTimeoutId = setTimeout(
        () => setTransitionEnded(true),
        SIDEBAR_TRANSITION_TIME
      );
      return () => clearTimeout(transitionTimeoutId);
    }
  }, [opened]);

  return transitionEnded;
}
